function Footer() {
    return (
        <div className="footer" aria-label="Footer with image attribution">Totoro images: imgbin.com || Animal images: flaticon.com (Freepik)</div>
    );
}

export default Footer; 